























































































































































import { Component, Vue } from 'vue-property-decorator';

   @Component({
    })

export default class ReservationRefund extends Vue{

  mockData:any[]=[];
  headers:any[]=[];
  startDate:Date=null;
  endDate:Date=null;
  breadcrumbsItems:any[]=[];
  checkbox:boolean= false;
  

    created(){
      this.headers= [
          { text: 'Seç',  align: 'start',filterable: false,   value: 'select', },
          { text: 'SMS Durumu', value: 'customer' },
          { text: 'İade Tarihi', value: 'refund Date' },
          { text: 'Geri Ödeme Durumu', value: 'refundStatus' },
          { text: 'Geri Ödenecek', value: 'refundTo' },
          { text: 'İade Türü', value: 'refundType' },
          { text: 'Toplam Ücret', value: 'totalPrice' },



        ],
        this.mockData=[
          {
            customer: 'xxx',
            refundDate: 'yyy',
            refundStatus: 'zzz',
            refundTo: 'aaa',
            refundType: 'uuu',
            totalPrice: 'kkk',
          },

        ]

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Bilet',disabled: true},
          {text: 'Rezervayon İadeleri',disabled: true}
        
      ]

    }

    data () {
      return {
        page: 1,
        
      }
      

    
}

}


